<template>
    <TotemSelect
        :options="contentTypeOptions"
        :placeholder="$t('ContentListFilter.content_type')"
        @input="selectContentType"
        class="filter-select"
        ref="selectContentType"
    />
</template>

<script>

    import { mapGetters } from 'vuex'

    export default {
        name: 'contentTypeFilter',
        data () {
            return {
                contentTypeOptions: [
                    { label: this.$t('ContentListFilter.learning_paths'), id: 0 },
                    { label: this.$t('ContentListFilter.courses'), id: 1 }
                ]
            }
        },
        computed: {
            ...mapGetters({
                selectedContentType: 'CourseFilter/getSelectedContentType'
            })
        },
        methods: {
            filterByContentType (data) {
                if (this.selectedContentType === null) {
                    return data
                }
                return data.filter(content => {
                    if (this.selectedContentType.id === 0) {
                        return content.type.value === 'learning_path'
                    } else {
                        return content.type.value !== 'learning_path'
                    }
                })
            },
            selectContentType (option) {
                this.$store.dispatch('CourseFilter/selectContentType', option)
            },
            clear () {
                this.$store.dispatch('CourseFilter/clearSelectedContentType')
            }
        }
    }
</script>
